import { Box, Typography } from "@mui/material";

export const NoMoreItemsIndicator = ({
  message = "You've reached the end",
  subMessage = "No more items to load",
}: {
  message?: string;
  subMessage?: string;
}) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 4,
        mb: 4,
        py: 3,
        px: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
      data-cypress="no-more-items"
    >
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        🎉 {message}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: "text.disabled",
          mt: 0.5,
          display: "block",
        }}
      >
        {subMessage}
      </Typography>
    </Box>
  );
};

